import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalHeader, ModalFooter, Input} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Select from "react-select";
import UserRoles from "../../constants/UserRoles";

export default class WoClearCodes extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Wo_Clear_Codes._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.user = null;
		this.state.users = [];
		this.state.generateModal = false;
		this.state.generateUser = null;
		this.state.generateReason = "";
		this.state.generatedCode = null;
		this.state.generating = false;
		this.state.copied = false;
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getUsers();
	}

	getUsers = async () => {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		model.limit = 100;
		model.filter = {bookableOnly: true};
		const result = await model.submit(null, "GET_FIELD_ENGINEERS");
		this.setState({
			users: result?.items || [],
		});
	}

	fetchData = async (state) => {
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.user = this.state.user?.value;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	engineerOptions = () => {
		return (this.state.users || []).map((user) => ({
			value: user.pkey,
			label: user.name_first + " " + user.name_last,
		}));
	}

	openGenerateModal = () => {
		this.setState({
			generateModal: true,
			generateUser: this.state.user,
			generateReason: "",
			generatedCode: null,
			generating: false,
			copied: false,
		});
	}

	closeGenerateModal = () => {
		this.setState({
			generateModal: false,
			generateReason: "",
			generatedCode: null,
			generating: false,
			copied: false,
		});
	}

	submitGenerate = async () => {
		const target = this.state.generateUser?.value;
		const reason = String(this.state.generateReason || "").trim();
		if (!target) {
			window.alert("Select an engineer before generating a code.");
			return;
		}
		if (!reason) {
			window.alert("Enter a short reason before generating a code.");
			return;
		}

		this.setState({generating: true});
		const model = new API.BuildClass(Types.Users._name, "POST_WO_CLEAR_ISSUE");
		model.object = {target_user: target, reason};
		try {
			const result = await model.submit(null, "POST_WO_CLEAR_ISSUE");
			const payload = result?.response ?? result;
			if (payload?.code) {
				this.setState({generatedCode: payload.code, generating: false});
				return;
			}
			const message = typeof payload === "string"
				? payload
				: (payload?.error || payload?.message || "No confirmed offline code is available. The Field Engineer must complete an online Calendar refresh first.");
			window.alert(message);
			this.setState({generating: false});
		} catch (error) {
			window.alert("The authorization code could not be issued. " + (error?.message || error));
			this.setState({generating: false});
		}
	}

	copyGeneratedCode = async () => {
		const code = this.state.generatedCode;
		if (!code) return;
		try {
			if (navigator?.clipboard?.writeText) {
				await navigator.clipboard.writeText(code);
			} else {
				window.prompt("Copy this authorization code", code);
			}
			this.setState({copied: true});
		} catch (error) {
			window.alert("The code could not be copied. " + (error?.message || error));
		}
	}

	formatWhen = (value) => {
		return value ? moment(value).local().format("MM/DD/YYYY h:mm A") : "";
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const canGenerate = (this.props.roles || []).some((role) =>
			[UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk].includes(role)
		);
		const columns = [
			{
				Header: "Used",
				id: "consumed_at",
				accessor: (obj) => this.formatWhen(obj.consumed_at),
			},
			{
				Header: "Engineer",
				id: "engineer_name",
				accessor: (obj) => obj.engineer_name,
			},
			{
				Header: "Issued By",
				id: "issuer_name",
				accessor: (obj) => obj.issuer_name,
			},
			{
				Header: "Issued",
				id: "issued_at",
				accessor: (obj) => this.formatWhen(obj.issued_at),
			},
			{
				Header: "Reason",
				id: "reason",
				accessor: (obj) => obj.reason,
			},
			{
				Header: "Offline",
				id: "consumed_offline",
				width: 90,
				accessor: (obj) => obj.consumed_offline ? "Yes" : "No",
			},
		];

		return (
			<Card>
				<div className={"row"} style={{alignItems: "center", padding: "12px 16px 0"}}>
					<div className={"col-4"}>
						<Select
							placeholder={"Engineer Select"}
							isMulti={false}
							isClearable
							value={this.state.user}
							onChange={async (value) => {
								this.state.user = value;
								this.setState({user: value});
								await this.fetchData();
							}}
							options={this.engineerOptions()}
							styles={this.styles}
						/>
					</div>
					<div className={"col-2"}>
						{canGenerate && (
							<Button color="warning" onClick={this.openGenerateModal}>
								Generate
							</Button>
						)}
					</div>
					<div className={"col-6"}>
						<div className="d-flex" style={{marginRight: "15px"}}>
							{this.renderHeaderRight("Wo_Clear_Codes", columns)}
						</div>
					</div>
				</div>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined,
						}}
						defaultSorted={[
							{
								id: "consumed_at",
								desc: true,
							},
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<Modal
						isOpen={this.state.generateModal}
						toggle={this.closeGenerateModal}
						backdrop={true}
					>
						<ModalHeader toggle={this.closeGenerateModal}>
							Issue Delete WO Data code
						</ModalHeader>
						<ModalBody>
							{this.state.generatedCode ? (
								<div>
									<p>Give this code to the Field Engineer. It cannot be shown again. It was already sent to their app on Calendar refresh.</p>
									<pre style={{
										fontSize: "1.6rem",
										letterSpacing: "0.12em",
										textAlign: "center",
										padding: "12px",
										background: "#f4f4f4",
									}}>{this.state.generatedCode}</pre>
								</div>
							) : (
								<div>
									<p>This selects a code already on the Field Engineer&apos;s device from their last successful Calendar refresh. It does not create a new code.</p>
									<div className="form-group">
										<Select
											placeholder={"Engineer"}
											isMulti={false}
											isClearable
											value={this.state.generateUser}
											onChange={(value) => this.setState({generateUser: value})}
											options={this.engineerOptions()}
											styles={this.styles}
											menuPortalTarget={typeof document !== "undefined" ? document.body : null}
											menuPosition="fixed"
										/>
									</div>
									<div className="form-group">
										<Input
											type="textarea"
											placeholder="Reason for issuing a Delete WO Data code"
											value={this.state.generateReason}
											onChange={(event) => this.setState({generateReason: event.target.value})}
										/>
									</div>
								</div>
							)}
						</ModalBody>
						<ModalFooter>
							{this.state.generatedCode ? (
								<>
									<Button color="secondary" onClick={this.copyGeneratedCode}>
										{this.state.copied ? "Copied" : "Copy"}
									</Button>
									<Button color="primary" onClick={this.closeGenerateModal}>Done</Button>
								</>
							) : (
								<>
									<Button color="secondary" onClick={this.closeGenerateModal}>Cancel</Button>
									<Button
										color="warning"
										disabled={this.state.generating}
										onClick={this.submitGenerate}
									>
										Generate
									</Button>
								</>
							)}
						</ModalFooter>
					</Modal>
				</CardContent>
			</Card>
		);
	}

	customStyles = {
		control: (provided) => ({
			...provided,
			minHeight: 32,
		}),
		valueContainer: (provided) => ({
			...provided,
			padding: "1px 6px",
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: 4,
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 3,
		}),
		menuPortal: (provided) => ({
			...provided,
			zIndex: 9999,
		}),
	};

	styles = {
		...this.customStyles, ...{
			container: (provided) => ({
				...provided,
			}),
			control: (provided) => ({
				...provided,
				minHeight: "30px",
			}),
			valueContainer: (provided) => ({
				...provided,
				overflow: "visible",
				padding: "1px 8px",
			}),
			placeholder: (provided, state) => ({
				...provided,
				position: "absolute",
				top: -4,
				left: -4,
				marginLeft: 0,
				marginRight: 0,
				fontSize: "1rem",
				color: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "rgba(0, 0, 0, 0.54)",
				transition: "top 200ms, margin-left 200ms, background-color 200ms, font-size 200ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
				transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) ? "translate(14px, -6px) scale(0.75) !important" : "translate(14px, 10px) scale(1) !important",
				transformOrigin: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "top left",
				backgroundColor: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "white",
				padding: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "0 8px",
			}),
			multiValue: (provided) => ({
				...provided,
				zIndex: 2,
			}),
		},
	};
}
